export function getPromise() {
  let resolve = (value: unknown) => {},
    reject = (value: unknown) => {}
  const resPorimse = new Promise((res, rej) => {
    resolve = res
    reject = rej
  })
  return [resPorimse, resolve, reject]
}

export async function loadScript(src: string) {
  const [promise, resolvePromise, rejectPromise] = getPromise()
  const scriptDOM = document.createElement('script')
  scriptDOM.src = src
  scriptDOM.onload = function () {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    resolvePromise()
  }
  scriptDOM.onerror = function (ex) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    rejectPromise(ex)
  }
  document.body.appendChild(scriptDOM)
  return promise
}

export function loadScriptInit(){
  const src = 'https://ux-listen.s3.cn-north-1.jdcloud-oss.com/pc-scene-research/ux-scene-research-v3.js'
  return loadScript(src)
}

export function openCustomerFeedback(config: {
  onClickClose?: () => void
  onClickSubmit?: () => void
  app?: string
  appSecret?: string
  loginType?: number
  sceneId: number | string
  isDialogVisible?: boolean
}) {
  const {
    app = 'market-center',
    appSecret = 'D18514A0091749DBA5E4B2A8FE5B1777',
    onClickClose,
    onClickSubmit,
    isDialogVisible = true,
    ...resetConfig
  } = config

  function done() {
    try {
      ;(window as any).renderUxSceneResearch &&
        (window as any).renderUxSceneResearch({
          app: '',
          appSecret: '',
          sceneId: '',
        })
    } catch (ex) {
      // eslint-disable-next-line no-console
      console.error(ex)
    }
  }

  const _config = {
    app,
    appSecret,
    isDialogVisible,
    onClickClose() {
      done()
      onClickClose && onClickClose()
    },
    onClickSubmit() {
      done()
      onClickSubmit && onClickSubmit()
    },
    ...resetConfig,
  }

  function open() {
    try {
      ;(window as any).renderUxSceneResearch(_config)
    } catch (ex) {
      // eslint-disable-next-line no-console
      console.error(ex)
    }
  }

  if ((window as any).renderUxSceneResearch) {
    return open()
  }

  loadScriptInit().then(()=>{
    if ((window as any).renderUxSceneResearch) {
      open()
    }
  })
}
